import axios from 'axios';
import { QUICKBOOKS_CONFIG, getQuickBooksCredentials } from '../../../config/quickbooks';
import { ERROR_MESSAGES } from '../config/qbConstants';
import { createBasicAuthCredentials, createTokenInfo, createRefreshTokenResponse } from '../utils/qbHelpers';
import { handleTokenError } from '../api/errorHandler';

// Exchange authorization code for access token
export const exchangeCodeForToken = async (code, state, realmId) => {
  try {
    // Get global QB credentials from admin settings
    const qbCredentials = await getQuickBooksCredentials();
    
    const tokenData = {
      grant_type: 'authorization_code',
      code: code,
      redirect_uri: QUICKBOOKS_CONFIG.REDIRECT_URI
    };

    const credentials = createBasicAuthCredentials(qbCredentials.clientId, qbCredentials.clientSecret);
    
    const response = await axios.post(QUICKBOOKS_CONFIG.TOKEN_URL, 
      new URLSearchParams(tokenData), 
      {
        headers: {
          'Accept': 'application/json',
          'Authorization': `Basic ${credentials}`,
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }
    );

    if (response.data && response.data.access_token) {
      return createTokenInfo(response.data, realmId);
    } else {
      throw new Error(ERROR_MESSAGES.QB_OAUTH_INVALID);
    }
  } catch (error) {
    handleTokenError(error, 'token exchange');
  }
};

// Refresh access token using refresh token
export const refreshAccessToken = async (refreshToken) => {
  try {
    // Get global QB credentials from admin settings
    const qbCredentials = await getQuickBooksCredentials();
    
    const tokenData = {
      grant_type: 'refresh_token',
      refresh_token: refreshToken
    };

    const credentials = createBasicAuthCredentials(qbCredentials.clientId, qbCredentials.clientSecret);
    
    const response = await axios.post(QUICKBOOKS_CONFIG.TOKEN_URL,
      new URLSearchParams(tokenData),
      {
        headers: {
          'Accept': 'application/json',
          'Authorization': `Basic ${credentials}`,
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }
    );

    if (response.data && response.data.access_token) {
      return createRefreshTokenResponse(response.data);
    } else {
      throw new Error(ERROR_MESSAGES.QB_TOKEN_REFRESH_FAILED);
    }
  } catch (error) {
    handleTokenError(error, 'refresh');
  }
};